"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = MoonDialBalances;
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utilities = require("@sart/utilities");
var _Space = _interopRequireDefault(require("./Space"));
var _MoonDial = _interopRequireDefault(require("./MoonDial"));
function MoonDialBalances(props) {
  var loading = props.loading,
    balances = props.balances;
  return /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.container
  }, /*#__PURE__*/_react["default"].createElement(_MoonDial["default"], {
    name: "Texts",
    size: 96,
    value: balances.text ? balances.text.quantity : 0,
    range: balances.text ? balances.text.startingQuantity : 0,
    loading: loading
  }), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    width: 2
  }), /*#__PURE__*/_react["default"].createElement(_MoonDial["default"], {
    name: "Data",
    format: function format(val) {
      return (0, _utilities.prettyBytes)(val);
    },
    size: 120,
    value: balances.data ? balances.data.quantity * 1000 : 0,
    range: balances.data ? balances.data.startingQuantity * 1000 : 0,
    loading: loading
  }), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    width: 2
  }), /*#__PURE__*/_react["default"].createElement(_MoonDial["default"], {
    name: "Minutes",
    size: 96,
    value: balances.voice ? parseInt(balances.voice.quantity / 60) : 0,
    range: balances.voice ? parseInt(balances.voice.startingQuantity / 60) : 0,
    loading: loading
  }));
}
var styles = _reactNative.StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    alignItems: 'flex-end'
  }
});
MoonDialBalances.defaultProps = {
  balances: {
    text: {
      quantity: 0,
      startingQuantity: 0
    },
    data: {
      quantity: 0,
      startingQuantity: 0
    },
    voice: {
      quantity: 0,
      startingQuantity: 0
    }
  }
};
var PropTypesBalance = _propTypes["default"].shape({
  quantity: _propTypes["default"].number,
  startingQuantity: _propTypes["default"].number
});
var PropTypesBalances = _propTypes["default"].shape({
  text: PropTypesBalance,
  data: PropTypesBalance,
  voice: PropTypesBalance
});
MoonDialBalances.propTypes = {
  balances: PropTypesBalances
};